import { Workbook } from "exceljs";

class DownloadHelper {
    data: Blob = null;
    type = '.txt';

    constructor(data?: any) {
        if (data) {
            this.data = new Blob(data, { type: 'text' });
        }
    }

    download(fileName: string) {
        if (this.data) {
            fileName = fileName + this.type;
            const downloadLink = document.createElement('a');
            downloadLink.style.display = 'none';
            downloadLink.download = fileName;
            downloadLink.href = window.URL.createObjectURL(this.data);
            document.body.appendChild(downloadLink);
            downloadLink.click();
        } else {
            console.error('No Data to download');
        }
    }
}

export class CSVDownloadHelper extends DownloadHelper {

    constructor(data?: any) {
        super();
        this.type = '.csv';
    }

    formatCSVData(data: any) {
        data = data.map(item => item.join()).join('\n');
        this.data = new Blob([data], { type: 'text/csv' });
    }
}

export class JSONDownloadHelper extends DownloadHelper {

    constructor() {
        super();
        this.type = '.json';
    }

    formatJSONData(data: any) {
        this.data = new Blob([JSON.stringify(data)], { type: 'application/json' });
    }
}

export class XlsxDownloadHelper extends DownloadHelper {
    constructor() {
        super();
        this.type = '.xlsx';
    }

    async formatXLSXData(data: any) {
        try {
            if (data) {
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('Books Data');
                worksheet.addRows(data);
                worksheet.columns.forEach((column) => {
                    let length = 0;
                    column.eachCell({ includeEmpty: true }, (cell) => {
                        const columnLength = cell.value ? cell.value.toString().length : 10;
                        if (columnLength > length) {
                            length = columnLength;
                        }
                    });
                    column.width = length < 10 ? 10 : length;
                })
                const buffer = await workbook.xlsx.writeBuffer()
                this.data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                
            } else {
                console.error('No Data to download');
            }
        } catch (error) {
            console.error(error, 'Error while trying to download file.');
        }
    }


}